import * as React from 'react';
import { isEmpty } from 'lodash';
import AkTextArea from '@atlaskit/textarea';
import { FieldBase } from '@atlassian/help-center-common-component/fields/field-base';
import type { FieldFormProps } from '@atlassian/help-center-common-component/fields/types';

export interface Props extends FieldFormProps<string> {
    maxLength?: number;
    minimumRows?: number;
    defaultValue?: string;
    placeholder?: string;
    isLabelHidden?: boolean;
    enableResize?: boolean;
}

export default class TextArea extends React.PureComponent<Props> {
    onChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.id, e.target.value, false, { rawObject: e });
        }
    };

    render() {
        const {
            id,
            required,
            label,
            defaultValue,
            description,
            maxLength,
            minimumRows,
            errorMessage,
            disabled,
            placeholder,
            isLabelHidden,
            enableResize,
        } = this.props;
        const isInvalid = !isEmpty(errorMessage);

        return (
            <FieldBase
                htmlFor={id}
                required={required}
                description={description}
                label={label}
                errorMessage={errorMessage}
                noLabel={isLabelHidden}
            >
                <AkTextArea
                    id={id}
                    name={id}
                    defaultValue={defaultValue}
                    maxLength={maxLength}
                    minimumRows={minimumRows}
                    resize={enableResize === undefined || enableResize ? 'vertical' : 'none'}
                    isInvalid={isInvalid}
                    onChange={this.onChange}
                    isDisabled={disabled}
                    placeholder={placeholder}
                />
            </FieldBase>
        );
    }
}
